<template>
    <div>
        <el-upload :class="{ hide: disabled ? disabled : hideUpload }" :multiple="multiple" :headers="uploadHeader"
            :action="posturl" list-type="picture-card" :file-list="fileList" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :limit="limit"
            :disabled="disabled" :on-exceed="onExceed">
            <el-button v-show="false" ref="telUpload">上传</el-button>
            <el-dropdown v-if="baseFlag || needNet" @command="handleCommand" trigger="click">
                <div @click.stop="preventNative" class="up-button flex-c-c-c">
                    <i class="el-icon-plus"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="upload">本地上传</el-dropdown-item>
                    <el-dropdown-item v-if="baseFlag" command="tobase" divided>从素材库选择</el-dropdown-item>
                    <el-dropdown-item v-if="needNet" command="internet" divided>网络路径</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <div v-else @click.stop="openUpload" class="up-button flex-c-c-c">
                <i class="el-icon-plus"></i>
            </div>
            <div class="avatar img-avatar" slot="file" slot-scope="{ file }">
                <el-image :key="file.url" fit="cover" :src="checkExt(file.url)"></el-image>
                <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="!disabled" class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
                        <i class="el-icon-delete"></i>
                    </span>
                    <div v-if="file.original_name || file.title"
                        :title="file.original_name ? file.original_name : file.title" class="el-title-text hideLine1">
                        {{ file.original_name || file.title }}
                    </div>
                </span>
            </div>
            <div v-if="uploadtips" :style="fileList.length>0?'margin-top:-12px;':''" slot="tip" class="el-upload__tip">
                {{ uploadtips }}
            </div>
        </el-upload>
        <el-dialog :append-to-body="true" v-if="preview" :visible.sync="dialogVisible" title="图片预览">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <el-dialog :close-on-click-modal="false" width="800px" :append-to-body="true" :visible.sync="dialogVisible2"
            title="网络路径">
            <div class="net-box">
                <el-row :gutter="10">
                    <el-col :span="22">
                        <el-input v-model="net_url" placeholder="请输入素材网络路径"></el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button @click="netUp()" type="primary">上传</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>
<script>
let that;
import bus from "../bus.js";
import fileimg from "../images/sucai_file_default_icon2.png";
import uploadingimg from "../images/uploading_now.png";
export default {
    name: "UploadFiles",
    props: {
        //是这个组件的识别码，因为一个页面可能会重复使用此组件
        //用来让素材库弹窗组件识别应该把选中的图片回显到哪个上传组件之中
        name: {
            default: 1,
        },
        baseFlag: {
            //是否需要使用素材库选择功能
            //设置为false就是和普通upload一样点击直接触发上传文件
            type: Boolean,
            default: true,
        },
        needNet: {
            //是否需要网络路径上传功能功能
            type: Boolean,
            default: false,
        },
        disabled: {
            //是否禁用
            type: Boolean,
            default: false,
        },
        // 文件可以选择的类型,是用来限制素材库弹窗里下拉框的选项
        //图片 1，视频 2，音频 3，文档 4，音视频 5。
        //数组内容是需要的文件类型，没有包括在这个数组里的值就是需要禁用的类型
        fileType: {
            type: Array,
            default: () => [1, 4],
        },
        //上传时是否可多选
        //现在多选有些问题
        multiple: {
            type: Boolean,
            default: true,
        },
        preview: {
            //是否需要预览弹窗
            type: Boolean,
            default: true,
        },
        uploadHeader: {}, //Authorization
        posturl: {
            //上传图片接口地址
            type: String,
            default: process.env.VUE_APP_API_ROOT + "admin/file/files",
        },
        list: {
            //图片列表
            type: Array,
            default: () => [],
        },
        imgsuffixs: {
            //限定图片上传后缀
            type: Array,
            default: () => [],
        },
        filesuffixs: {
            //限定文件上传后缀
            type: Array,
            default: () => [],
        },
        uploadFormatDesc: {
            //上传格式描述
        },
        uploadSizeDesc: {
            //上传大小描述
            type: String,
        },
        limitCount: {
            //上传文件数量限制
            type: Number,
            default: 99,
        },
        limitSize: {
            //上传文件大小限制 单位为MB
            type: Number,
            default: 50,
        },
    },
    data() {
        return {
            net_url: "",
            fileimg: fileimg,
            uploadingimg:uploadingimg,
            limit: 99,
            uploadtips: "",
            suffixs: [],
            dialogImageUrl: "",
            dialogVisible: false,
            dialogVisible2: false,
            hideUpload: false, //是否隐藏上传按钮
        };
    },
    watch: {
        limitCount: {
            handler(n, o) {
                this.limit = n;
            },
            immediate: true,
        },
        uploadFormatDesc: {
            handler(n, o) {
                if (n) {
                    this.uploadtips = n;
                } else if (n === false || n === "false") {
                    this.uploadtips = "";
                } else {
                    this.$nextTick(() => {
                        let tip = [];
                        if (this.imgsuffixs.length > 0) {
                            let a = `图片只能上传${this.imgsuffixs.join("/")}文件`;
                            tip.push(a);
                        }
                        if (this.filesuffixs.length > 0) {
                            let b = `文件只能上传${this.filesuffixs.join("/")}文件`;
                            tip.push(b);
                        }
                        if (this.limitSize) {
                            let c = `大小不超过${this.limitSize}M`;
                            tip.push(c);
                        }
                        this.uploadtips = tip.join(",");
                    });
                }
            },
            immediate: true,
        },

        list: {
            handler(n, o) {
                // console.log("newValue", n);
                this.hideUpload = this.list.length >= this.limit;
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        fileList() {
            return this.list;
        },
    },
    created() {
        that = this;
        let myname = this.name;
        bus.$on("returnChosen", (chosen, name) => {
            //   if (name == myname) {
            //     this.fileList.concat(chosen);
            //   }
            //   console.log("busreturn",this.fileList)
            //   debugger;
        });
    },
    beforeDestroy() {
        bus.$off("returnChosen");
    },
    mounted() {
        let list = this.list;
        // this.fileList = list;
    },
    methods: {
        netUp() {
        },

        checkExt(url) {
            if(url.includes("blob")){
                return uploadingimg;
            }
            let ext = url.split(".");
            let extension = ext[ext.length - 1].toLowerCase();
            if (extension == "jpg" || extension == "jpeg" || extension == "png" || extension == "webp" || extension == "tiff" || extension == "tif" || extension == "gif" || extension == "svg" || extension == "bmp") {
                console.log(1,url)
                return url;
            } else {
                console.log(2,url)
                return fileimg;
            }
        },
        handleRemove(file) {
            //删除视频
            let list = this.list;
            let fileIndex = list.findIndex((item) => item.uid == file.uid);
            list.splice(fileIndex, 1);
            this.$emit("filechange", file, list);
        },
        handleCommand(command) {
            if (command == "upload") {
                this.openUpload();
            } else if (command == "tobase") {
                let list = this.list;
                let limit = Number(this.limit) - Number(list.length);
                bus.$emit("openbase", limit, this.fileType, this.name);
            } else if (command == "internet") {
                this.dialogVisible2 = true;
            }
        },
        openUpload() {
            this.$refs.telUpload.$el.click();
        },
        preventNative(event) {
            event.stopPropagation();
        },
        upFile(event) {
            //   event.stopPropagation();
            this.$refs.telUpload.$el.click();
        },
        onExceed() {
            this.$message.warning(`文件上传超过限制,最多可上传${this.limit}个文件`);
        },
        handlePictureCardPreview(file) {
            console.log("Preview", file);
            let url = "";
            let ext = "";
            if (file.response) {
                url = file.response.url;
            } else {
                url = file.url;
            }
            ext = url.split(".");

            let extension = ext[ext.length - 1].toLowerCase();
            if (extension == "jpg" || extension == "jpeg" || extension == "png") {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            } else {
                window.open(url);
            }
        },
        handleAvatarSuccess(res, file, fileList) {
            this.fileFlag = false;
            if (res.code && res.code != "200") {
                that.$message.error(res.message ? res.message : "上传失败!");
                fileList.splice(fileList.indexOf(file), 1);
                return false;
            } else {
                let list = [];
                if (
                    fileList.every((item) => {
                        if (item.response) {
                            if (item.response.url.indexOf("blob:") == -1) {
                                return true;
                            }
                        } else {
                            if (item.url.indexOf("blob:") == -1) {
                                return true;
                            }
                        }
                    })
                ) {
                    fileList.map((item) => {
                        /** 这时只需要push进带有response的数据就好 */
                        if (item.response) {
                            list.push({
                                ...item.response,
                            });
                        } else {
                            list.push({
                                ...item,
                            });
                        }
                    });
                    this.$emit("addFile", list);
                }
                //   let pathList = list.map((s) => {
                //     return s.response.path;
                //   });
                // let pathList = [];
                // for (let s of list) {
                //   pathList.push(s.response);
                // }
                // this.$emit("addFile", res);
            }
        },
        beforeAvatarUpload(file) {
            // debugger
            this.suffixs = this.imgsuffixs.concat(this.filesuffixs);
            let suffixs = this.suffixs.flatMap((format) => [
                format,
                format.toUpperCase(),
            ]);
            const isLt10M = file.size / 1024 / 1024 < this.limitSize;
            const type = file.name.split(".");
            if (suffixs.indexOf(type[type.length - 1]) == -1) {
                this.$message.error("请上传正确的文件格式：" + this.uploadtips);

                return false;
            }
            if (!isLt10M) {
                this.$message.error(
                    this.uploadSizeDesc
                        ? this.uploadSizeDesc
                        : `上传文件大小不能超过${this.limitSize}M`
                );
                return false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep .hide .el-upload--picture-card {
    display: none;
}

.img-avatar {
    width: 100%;
    height: 100%;
    display: grid;
}

::v-deep {
    .el-upload-list--picture-card{
        // padding: 0;
        // height: 80px;
        // display: inline-block;
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
        display: none;
    }

    .el-upload-list__item {
        transition: none !important;
    }

    .el-upload--picture-card {
        width: 80px !important;
        height: 80px !important;
        border: none !important;
        box-sizing: border-box;
    }

    .el-upload-list--picture-card .el-upload-list__item {
        width: 80px !important;
        height: 80px !important;
        border-radius: 2px;
    }

    .el-dropdown {
        width: 100%;
        height: 100%;
        display: block;
    }

    .img-avatar .el-image {
        width: 100%;
        height: 100%;
    }
}

.el-title-text {
    position: absolute;
    bottom: 0;
    font-size: 14px;
}

.up-button {
    width: 100%;
    height: 100%;
    // border: 1px dashed #c0ccda;
    border-radius: 0px;
    background: #F8F7F5;

    .el-icon-plus {
        // transform: translateY(-20%);
    }
}

.net-box {
    padding: 20px 20px;
}
</style>
